import { render, staticRenderFns } from "./NewAssistent.vue?vue&type=template&id=d33c0888&"
import script from "./NewAssistent.vue?vue&type=script&lang=js&"
export * from "./NewAssistent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports